export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    $('.ancora').click(function() {
      if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
      if (target.length) {
          $('html,body').animate({
          scrollTop: target.offset().top,
          }, 700);
          return false;
      }
      }
    });
    
    $('.slider-home-mob').owlCarousel({
      loop:true,
      margin:0,
      items:1,
      //nav:true,
      dots:true,
      autoplay:true,
      autoplayHoverPause:true,
      autoplayTimeout:6000,
      //navText: ['<i class="fa fa-angle-left"></i>','<i class="fa fa-angle-right"></i>'],
    });

    $('.carousel-sobre-nos').owlCarousel({
      loop:true,
      margin:0,
      nav:true,
      //dots:true,
      autoplay:true,
      autoplayHoverPause:true,
      autoplayTimeout:6000,
      navText: ['<i class="fa fa-angle-left"></i>','<i class="fa fa-angle-right"></i>'],
      responsive:{
        0:{
          items:1,
        },
        600:{
          items:1,
        },
        1000:{
          items:4,
        },
      },
    });

    $('.carousel-blog').owlCarousel({
      loop:true,
      margin:0,
      nav:true,
      //dots:true,
      autoplay:true,
      autoplayHoverPause:true,
      autoplayTimeout:6000,
      navText: ['<i class="fa fa-angle-left"></i>','<i class="fa fa-angle-right"></i>'],
      responsive:{
        0:{
          items:1,
        },
        600:{
          items:1,
        },
        1000:{
          items:3,
        },
      },
    });

    $('.docs-slider').owlCarousel({
      loop:true,
      margin:0,
      nav:true,
      autoplayTimeout:6000,
      navText: ['<i class="fa fa-angle-left"></i>','<i class="fa fa-angle-right"></i>'],
      responsive:{
        0:{
          items:2,
        },
        600:{
          items:1,
        },
        1000:{
          items:2,
        },
      },
    });

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js